(function () {
    'use strict';

    const mobile_panel_container = document.querySelectorAll('.header-mobile__panel');

    if (!mobile_panel_container) {
        return;
    }

    const mobile_panels = document.querySelector('.header-mobile__panels');
    const triggers = mobile_panels.querySelectorAll('[gr-trigger-panel]');
    const navIcon = document.querySelector('.header__nav-icon');
    const panelBack = document.querySelectorAll('.panel__link--back');



    for (let index = 0; index < triggers.length; index++) {
        triggers[index].addEventListener('click', function (event) {

            if ( navIcon ) {
                navIcon.style.zIndex = 1;
            }

            event.preventDefault();

            var panel_id = this.getAttribute('gr-trigger-panel');
            hide_active_panel();
            show_panel(panel_id);
        });
    }


    function show_panel(id) {
        document.querySelector('#' + id).classList.add('is-active');
    }

    function hide_active_panel() {
        document.querySelector('.header-mobile__panel.is-active').classList.remove('is-active');
    }

    if (panelBack) {

        for (var y = 0, maxPanelBack = panelBack.length; y < maxPanelBack; y++) {
            panelBack[y].addEventListener('click', function (e) {
                e.preventDefault();
                if (navIcon) {
                    navIcon.style.zIndex = 52;

                    var panel_id = this.getAttribute('gr-trigger-panel');

                    hide_active_panel();
                    show_panel(panel_id);
                }
            });
        }


    }

    for (var x = 0, maxPanels = mobile_panel_container.length; x < maxPanels; x++) {
        console.log(mobile_panel_container[x]);
        mobile_panels.appendChild(mobile_panel_container[x]);
    }

})(window.groots);



(function () {
    'use strict';
    document.addEventListener('DOMContentLoaded', function () {
        const subnav1 = document.querySelector('.module-subnav-1');

        if (!subnav1) {
            return;
        }

        const triggers = subnav1.querySelectorAll('[gr-subnav-solution]');

        for (let index = 0; index < triggers.length; index++) {
            triggers[index].addEventListener('mouseover', function (event) {

                var panel_id = this.getAttribute('gr-subnav-solution');
                var panel_container = this.getAttribute('gr-subnav-solution-col');

                if (panel_container === '2') {
                    subnav1.querySelector('.solution-subnav__col-3').style.opacity = 0;
                }

                subnav1.querySelector('.solution-subnav__col-' + panel_container).style.opacity = 1;

                hide_active_panel(panel_container);
                show_panel(panel_id);
            });
        }

        function show_panel(id) {
            subnav1.querySelector('.' + id).classList.add('is-active');
        }

        function hide_active_panel(container) {
            var element = subnav1.querySelector('.solution-subnav__col-' + container + ' .solution-subnav__panel.is-active');
            if (element) {
                element.classList.remove('is-active');
            }
        }
    });

})(window.groots);

(function () {
    'use strict';

    const select = document.querySelector('[gr-trigger-link]');

    if (!select) {
        return;
    }

    select.addEventListener('change', triggerTab);

    function triggerTab() {
        var url = select[this.selectedIndex].getAttribute('value');

        if (url) {
            document.location.href = url;
        }
    }
}());
